import { render, staticRenderFns } from "./calendarResources.vue?vue&type=template&id=7028477a&"
import script from "./calendarResources.vue?vue&type=script&lang=js&"
export * from "./calendarResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports